export enum PanelButtonIcon {
  Info = 'info',
  Lightbulb = 'lightbulb',
}
